var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tagName,_vm._g(_vm._b({tag:"component",staticClass:"l-stack",class:`l-stack--${_vm.flows}`},'component',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }